// extracted by mini-css-extract-plugin
export var infoItem = "_mk-1";
export var title = "_mk-0";